import React, { useState } from 'react'
import clsx from 'clsx'
import * as R from 'ramda'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Skeleton } from '@material-ui/lab'
import { Typography, Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FormattedMessage, useIntl } from 'react-intl'

import { dateFormat } from 'commons/date'
import { VOUCHER_STATUS } from 'app/constants/voucher'

import PlainText from 'app/componentV4/PlainText'
import VoucherDetail from 'app/componentV4/MessageDetail/Voucher/VoucherDetail'

const useStyles = makeStyles((theme) => ({
  chipProps: {
    width: 'fit-content',
    height: '22px',
  },
  voucherActive: {
    backgroundColor: theme.palette.voucher.activeBadgeBg,
    color: theme.palette.voucher.activeBadgeTxt,
  },
  voucherExpired: {
    backgroundColor: theme.palette.voucher.expiredBadgeBg,
    color: theme.palette.voucher.expiredBadgeTxt,
  },
  voucherCanceled: {
    backgroundColor: theme.palette.voucher.canceledBadgeBg,
    color: theme.palette.voucher.canceledBadgeTxt,
  },
  voucherFullyRedeem: {
    backgroundColor: theme.palette.voucher.fullyRedeemBadgeBg,
    color: theme.palette.voucher.fullyRedeemBadgeTxt,
  },
}))

const Voucher = (props) => {
  const { data, isLoading } = props
  const { status, startTime, endTime, template, translated } = data

  const classes = useStyles()
  const { formatMessage } = useIntl()
  const chipProps = VOUCHER_STATUS[status]

  const [isOpen, isSetOpen] = useState(false)

  return (
    <>
      {isLoading ? (
        <div className="space-y-3 py-10">
          <Skeleton variant="rect" width="full" height={63} />
        </div>
      ) : (
        <div className={clsx('w-auto cursor-point py-10')}>
          <div className="w-full">
            <Typography className="text-primary font-bold text-16">
              <FormattedMessage id="timeline.detail.message.voucher.attachment.title" />
            </Typography>
          </div>
          <div
            className="w-fit flex flex-row my-5 cursor-pointer"
            onClick={() => isSetOpen(true)}
          >
            <img
              width={63}
              height={63}
              alt="voucherImage"
              src={R.prop('imageUrl', template)}
              className="rounded"
            />
            <div className="w-auto flex flex-col ml-16 justify-center space-y-2">
              <div className="flex">
                <Typography className="text-primary font-normal text-16">
                  <PlainText text={R.prop('title', translated) ?? ''} />
                </Typography>
                &nbsp;
                <Chip
                  className={clsx(
                    classes.chipProps,
                    classes[chipProps.classes],
                  )}
                  label={formatMessage({
                    id: chipProps.labelId,
                  })}
                />
              </div>

              <Typography className="text-grey-200 text-12 font-normal">
                <FormattedMessage
                  id="notificationTimeline.card.voucher.section.validFrom"
                  values={{
                    startDate: moment(startTime).format(dateFormat),
                    endDate: moment(endTime).format(dateFormat),
                  }}
                />
              </Typography>
            </div>
          </div>
        </div>
      )}

      <VoucherDetail
        data={data}
        onClose={() => isSetOpen(false)}
        isOpen={isOpen}
      />
    </>
  )
}

const valuePropTypes = {
  status: PropTypes.number,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  template: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    imageUrl: PropTypes.string,
    fontColor: PropTypes.string,
  }),
  translated: PropTypes.shape({
    body: PropTypes.string,
    title: PropTypes.string,
  }),
}
Voucher.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.shape(valuePropTypes).isRequired,
}
export default Voucher
